<!-- 预收款历史 -->
<template>
  <div class='page_content'>
    <processAuditAction ref="processAuditAction"></processAuditAction>
    <subComponents ref="showSelectData"></subComponents>
    <div class="page_content_top">
      <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo" @openFormDesign="openFormDesign"></v-button>
      <div class="page_content_top_line">
        <v-search v-if="pageShowData.jurHead" :searchList="pageShowData.jurHead.jurconfigform" :getRequestData="getRequestData" @searchData="searchData" @openSearch="openSearch"></v-search>
      </div>
    </div>
    <div class="page_content_center">
      <el-table v-if="pageShowData.jurTableVo" stripe ref="mainTable" :data="returnData.list" :height="tableHeight" :show-summary="true" :summary-method="getSummaries" :key="$store.state.tableNum" border style="width: 100%" highlight-current-row size="mini">
        <el-table-column label="选择操作" align="center" width="80">
          <template slot-scope="scope">
            <el-radio v-model="selectedDataIndex" :label="scope.$index" border size="mini">
              <i class="el-icon-thumb"></i>
            </el-radio>
          </template>
        </el-table-column>
        <el-table-column align="center" v-if="tableValye.isShow==1" v-for="(tableValye,tableKey) in pageShowData.jurTableVo.jurconfigtable" :key="tableKey" :prop="tableValye.entityField" show-overflow-tooltip
          :min-width="tableValye.fieldWeight" :label="tableValye.showField">
          <template slot-scope="scope">
            <el-tag size="mini" v-if="tableValye.entityField == 'isWms'">
              {{scope.row.isWms == 0 ? '否' : '是'}}
            </el-tag>
            <el-tag size="mini" v-else-if="tableValye.entityField == 'psomState'">{{$common.getIsGsp(tableValye.formatterContent,scope.row.psomState)}}</el-tag>
            <span v-else-if="tableValye.fieldType == 'date'">
             <span v-if="scope.row[tableValye.entityField]"> {{$common.getLocalTime(scope.row[tableValye.entityField])}}</span>
            </span>
            <span v-else-if="tableValye.fieldType == 'dateTime'">
             <span v-if="scope.row[tableValye.entityField]"> {{$common.getLocalTime(scope.row[tableValye.entityField],true)}}</span>
            </span>
            <span v-else-if="tableValye.fieldType == 'formatter'">{{$common.getIsGsp(tableValye.formatterContent,scope.row[tableValye.entityField])}}</span>
            <span v-else-if="tableValye.isRift == 1">
              <a @click="toDetail(scope.row[tableValye.riftField])">{{scope.row[tableValye.entityField]}}</a>
            </span>
            <span v-else>
              {{scope.row[tableValye.entityField]}}
            </span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="page_content_bottom">
      <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total" @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>
    </div>
    <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
      <SearchScheme ref="searchScheme" :id="seId" :smId="smId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
    </el-dialog>
    <!-- 自定义设计 -->
    <customDesign ref="customDesign"></customDesign>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "../../../byComponents/SearchScheme.vue";
import ExtractionScheme from "../../../byComponents/ExtractionScheme.vue";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    SearchScheme,
    ExtractionScheme,
  },
  data() {
    //这里存放数据
    return {
      tableHeight: 0,
      getRequestData: {
        psomBuycus: "",
        smName: "",
        page: 1,
        rows: 30,
        start:
          new Date(new Date().toLocaleDateString()).getTime() -
          31 * 24 * 3600 * 1000,
        end:
          new Date(new Date().toLocaleDateString()).getTime() +
          24 * 60 * 60 * 1000 -
          1,
        smId: "",
      },
      returnData: {
        pages: 0, // 总页数
        total: 0, // 总条数
        pageNum: 0, // 当前页数
        list: [],
      },
      buttonList: [],

      pageShowData: [],
      formDataList: [],
      selectedDataIndex: 0,
      selectedDetailsDataIndex: 0,
      exId: "",
      seId: "",
      ceshi: "",
      dialogTitle: "",
      seWidth: "",
      height: "",
      exTitle: "",
      seTitle: "",
      seWidth: "",
      exWidth: "",
      DialogVisible: false,
      DialogExtract: false,
      seType: "",
      smId: "",
      parentSearchData: {},
      sField: "",
      totalField:[],
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {
    "getRequestData.smName": {
      handler: function (newValue, oldValue) {
        if (newValue == "") {
          this.getRequestData.smId = "";
        }
      },
      deep: true,
    },
    selectedDataIndex: {
      handler: function (newValue, oldValue) {
        this.selectedDetailsDataIndex = 0;
      },
      deep: true,
    },
  },
  //方法集合
  methods: {
    // 自定义合计字段
    getSummaries(param) {
      const {
        columns,
        data
      } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (column.property=='payMoney') {
          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return this.toDecimal(prev + curr);
              } else {
                return this.toDecimal(prev)
              }
            }, 0);
            sums[index] = this.$common.getDecimalInfo(3, sums[index])
          } else {
            sums[index] = 'N/A';
          }
        } else {
          sums[index] = ''
        }
      });

      return sums;
    },
    toDecimal(x) {
      var f = parseFloat(x);
      if (isNaN(f)) {
        return;
      }
      f = Math.round(x * 100) / 100;
      return f;
    },
    // 点击穿透字段 传参单号
    toDetail(orderId) {
      //    console.log(orderId)
      if (orderId) {
        // 设置为true 打开穿透组件首页
        var isPenetrate = true;
        // 设置缓存 存入点击单号
        this.resetSetItem("penetrateOrderId", orderId);
        // 与父级跨域通信 传递isPenetrate参数
        window.parent.postMessage(
          {
            //向窗口发送MessageEvent消息
            cmd: "returnFormJson",
            params: { isPenetrate }, //参数
          },
          "*"
        );
      }
    },
    getSeWidth(e) {
      console.log(e);
      this.seWidth = e + "%";
    },
    getWidth(e) {
      console.log(e);
      this.exWidth = e + "%";
    },
    getSearchName(e) {
      console.log(e);
      this.seTitle = e;
    },
    getExtractName(e) {
      console.log(e);
      this.exTitle = e;
    },
    // 检索Id, 索引(表格中), 标识
    openSearch({ sId, index, type, sField }) {
      this.DialogVisible = true;
      this.seId = sId;
      this.sField = sField;
      this.parentSearchData[type] = this.getRequestData[type];
    },
    //检索带回数据
    changeInputModel(val) {
      if (val != "" || val != undefined) {
        this.DialogVisible = false;
        this.paramValue(val);
      }
    },
    // 赋值字段
    paramValue(val) {
      let arr = this.sField.split(",");
      arr.forEach((item) => {
        this.getRequestData[item] = val[item];
      });
    },
    isShowData(name, value) {
      switch (name) {
        case "supplier":
          var dataInfo = sessionStorage.getItem("selectSupplierData");
          if (dataInfo) {
            dataInfo = JSON.parse(dataInfo);
            this.getRequestData.psomBuycus = dataInfo.smId;
            this.getRequestData.smName = dataInfo.smName;
          }
          break;
      }
    },

    selectedDetailsDataAction(data) {
      var info = data.split(",").map(Number);
      this.selectedDataIndex = info[0];
    },

    // 获取数据列表
    async getPageInfo() {
      var pathId = parent.getMenuInfo(this.$route.path);
      let responseData = await this.$http.getJur({ ids: [pathId.jurId] });
      if (responseData.status == 200) {
        this.pageShowData = responseData.result;
        var obj = {}
        if (this.pageShowData.jurHead) {
          obj = this.$common.getSearchData(this.pageShowData.jurHead.jurconfigform, 'page', "rows", 30)
        } else {
          obj = this.$common.getSearch(this.getRequestData, 'start', 'end', 'page', 'rows', 30)
        }
        for (const key in obj) {
          this.$set(this.getRequestData, key, obj[key])
        }
        this.pageShowData.jurTableVo.jurconfigtable.forEach(item => {
          if (item.fieldType == 'number') {
            this.totalField.push(item.entityField)
          }
        })
        this.getDataList();
        console.log(this.pageShowData);
      } else {
        this.$message({
          message: responseData.message,
          type: "error",
        });
      }
    },
    // 动作集合
    actionSet(actionData) {
      console.log(actionData);
      switch (actionData.actionType) {
        case 5:
          var dataInfo = this.returnData.list[this.selectedDataIndex];
          if (!dataInfo) {
            this.$message({
              message: "请先选中要操作的数据",
              type: "error",
            });
            return false;
          }
          this.$refs["processAuditAction"].openBox(1, dataInfo.spamId);
          break;
        case 7:
          this.backOff()
          break;
      }
    },
    backOff() {
      if (this.returnData.list.length <= 0) {
        if (!dataInfo) {
          this.$message({
            message: "暂无数据",
            type: "error",
          });
          return false;
        }
      }
      if (!this.returnData.list[this.selectedDataIndex]) {
        this.$message({
          message: "请先选择您要操作的数据",
          type: "error",
        });
        return false;
      }
      var dataInfo = this.returnData.list[this.selectedDataIndex];
      this.$confirm("确定回退订单吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let data = {
            ids: [dataInfo.spamId],
          };
          let responseData = await this.$http.preregApplyGoBack(data);
          if (responseData.status == 200) {
            this.$message({
              message: responseData.message,
              type: "success",
            });
            this.getDataList();
          } else {
            this.$message({
              message: responseData.message,
              type: "error",
            });
          }
        })
        .catch(() => { });
    },
    openFormDesign() {
      let pathInfo = parent.getMenuInfo(this.$route.path)
      this.$refs['customDesign'].openBox(pathInfo.jurId, this.pageShowData, pathInfo.jurName)
    },

    // 数据搜索
    searchData() {
      this.getRequestData.page = 1;
      this.getDataList();
    },
    // 数据翻页
    setDataPageNumber(val) {
      this.getRequestData.page = val;
      this.getDataList();
    },

    // 切换显示条数
    setDataPageSize(val) {
      this.getRequestData.page = 1;
      this.getRequestData.rows = val;
      this.getDataList();
    },

    // 获取数据列表
    async getDataList() {
      if (this.getRequestData.coName == "") {
        this.getRequestData.coId = "";
      }
      let responseData = await this.$http.queryPreregApplyHis(
        this.getRequestData
      );
      if (responseData.status == 200) {
        this.returnData.list = responseData.result.list;
        console.log("this.returnData.list", this.returnData.list);
        this.returnData.pages = responseData.result.pages;
        this.returnData.total = responseData.result.total;
        this.returnData.pageNum = responseData.result.pageNum;
        this.selectedDataIndex = 0;
        this.$nextTick(() => {
          setTimeout(()=>{this.$refs.mainTable.doLayout()},100)
        })
      } else {
        this.$message({
          message: responseData.message,
          type: "error",
        });
      }
    },

    // 关闭
    submitDataAction() {
      var dataInfo = this.returnData.list[this.selectedDataIndex];
      if (!dataInfo) {
        this.$message({
          message: "请先选中要操作的数据",
          type: "error",
        });
        return false;
      }

      this.$confirm("确定要关闭订单?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let responseData = await this.$http.closePurchaseOrder({
            ids: [dataInfo.spamId],
          });
          if (responseData.status == 200) {
            this.$message({
              type: "success",
              message: "操作成功",
            });

            this.getDataList();
          } else {
            this.$message({
              message: responseData.message,
              type: "error",
            });
          }
        })
        .catch(() => { });
    },

    // 关闭明细
    submitDataActionDetails() {
      var dataInfo = this.returnData.list[this.selectedDataIndex];
      if (!dataInfo) {
        this.$message({
          message: "请先选中要操作的数据",
          type: "error",
        });
        return false;
      }
      if (this.selectedDetailsDataIndex == "") {
        this.$message({
          message: "请先选中要操作的促销商品",
          type: "error",
        });
        return false;
      }
      var selectInfo = this.selectedDetailsDataIndex.split(",").map(Number);
      var dataInfo =
        this.returnData.list[this.selectedDataIndex].pisOrderDetail[
        selectInfo[1]
        ];
      this.$confirm("确定要关闭订单明细?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let responseData = await this.$http.closePurchaseOrderDetails({
            ids: [dataInfo.psodId],
          });
          if (responseData.status == 200) {
            this.$message({
              type: "success",
              message: "操作成功",
            });

            this.getDataList();
          } else {
            this.$message({
              message: responseData.message,
              type: "error",
            });
          }
        })
        .catch(() => { });
    },
    //获取状态
    getIsGsp(str, val) {
      try {
        str && str.replace(/\\/g, "");
        let arr = JSON.parse(str);
        let len = arr.length;
        let newStr = "";
        for (let i = 0; i < len; i++) {
          if (arr[i].key === val) {
            newStr = arr[i].value;
            break;
          }
        }
        return newStr;
      } catch (ex) {
        return str;
      }
    },

    // 获取按钮权限
    async getButtonList() {
      this.buttonList = await this.$common.getActionButton()
      
    },
},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getPageInfo();
    this.getDataList();
    this.getButtonList();
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() { },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
  beforeDestroy() { }, //生命周期 - 销毁之前
  destroyed() { }, //生命周期 - 销毁完成
  activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_content_tag {
  margin-right: 1rem;
}

.el-tabs--border-card_new {
  height: 85vh;
  overflow-y: scroll;
}
</style>